export default class Polygon {
    constructor(data) {
        for (let key in data) {
            this[key] = data[key];
        }
    }

    getId() {
        return this.id;
    }

    getShapeId(index) {
        return this.id + '-' + index;
    }

    getOptions() {
        return {
            fillColor: '#8fdadb',
            fillOpacity: 0.5,
            strokeColor: '#73b1bf',
            strokeOpacity: 1,
            strokeWeight: 1.5,
        }
    }

    getShapes() {
        return this.polygons;
    }

    getLayer() {
        return this.type;
    }

    getLayerId() {
        return this.getLayer().id;
    }
}
